import { fromJS } from 'immutable'
import {
  OPEN_RESPONSE_MODAL,
  SET_KEYWORD_SEARCH,
} from '../../actions/sale-product/types'

const init = fromJS({
  keywordSearch: '',
  responseModal: {
    isOpen: false,
    res: {},
  },
})

export default (state = init, action) => {
  switch (action.type) {
    case OPEN_RESPONSE_MODAL:
      return state
        .set('responseModal', action.payload.responseModal)
    case SET_KEYWORD_SEARCH:
      return state
        .set('keywordSearch', action.payload.keywordSearch)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sale-product/sale-product-reducer.js